import React from 'react';

import cx from 'classnames';

import { TReview } from 'types/review';

import { Arrow } from '../Arrow/Arrow';
import { CtaViewMore } from '../CtaViewMore/CtaViewMore';
import { Title } from '../Title/Title';
import { Review } from './Review';

import s from './Reviews.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

type TProps = {
  aboutLink: string;
  currentReviewIndex: number;
  onShowNextReview: () => void;
  onShowPrevReview: () => void;
  reviews: TReview[];
};

export const ReviewCarousel = ({
  aboutLink,
  currentReviewIndex,
  onShowNextReview,
  onShowPrevReview,
  reviews,
}: TProps) => {
  if (reviews.length === 0) {
    return null;
  }

  return (
    <section className={s.reviews}>
      <div className={s1.content}>
        <div className={s.wrapper}>
          <Title className={s.title}>Reviews</Title>
          <div className={s.content}>
            {reviews.length > 0 && (
              <Review
                key={reviews[currentReviewIndex].id}
                review={reviews[currentReviewIndex]}
              />
            )}
          </div>
        </div>
      </div>

      {reviews.length > 1 && (
        <nav className={s.pagination} aria-label="pagination">
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowPrevReview}
            aria-label="Previous review"
          >
            <span className={cx(s.paginArrow, s.prevArrow)}>
              <Arrow />
            </span>
          </button>
          <span className={s.paginProgress}>
            {currentReviewIndex + 1} / {reviews.length}
          </span>
          <button
            type="button"
            className={s.paginButton}
            onClick={onShowNextReview}
            aria-label="Next review"
          >
            <span className={cx(s.paginArrow, s.nextArrow)}>
              <Arrow />
            </span>
          </button>
        </nav>
      )}

      <CtaViewMore to={aboutLink} title="View all reviews" />
    </section>
  );
};
